// extracted by mini-css-extract-plugin
export default {"lightTheme":"nvrt-light_theme","darkTheme":"nvrt-dark_theme"};